const { REACT_APP_BASE_URL_API, REACT_APP_KEY_AUTH } = process.env;

const BASE_URL_API = REACT_APP_BASE_URL_API || "https://despesa-api.mpma.mp.br/v1";
const KEY_AUTH_APP = REACT_APP_KEY_AUTH;

export const BASE_URL = BASE_URL_API;
export const KEY_AUTH = KEY_AUTH_APP;
